// extracted by mini-css-extract-plugin
export default {"container":"P0dxSSBJH8","uplink":"bFFG1uyMNN","downlink":"BHiEXXLswO","active":"_15FUz4Yi3I","icon":"jFfjewf+9a"};